/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import clsx from 'clsx';

import { getErrorDisplayText } from './inputHelpers';
import Fieldset from '../components/forms/Fieldset';

export interface CheckboxGroupProps {
  children?: React.ReactNode;
  className?: string;
  hasError?: boolean;
  error?: string | object;
  hint?: string;
  label?: string;
  onBlur?(event: React.FocusEvent): void;
  onChange?(event: React.ChangeEvent): void;
}

/**
 * @deprecated
 * Plase see ui folder of your project
 * Use `CheckboxGroup` to group a list of checkboxes.
 *
 * ```js
 * import { CheckboxGroup } from '.';
 * ```
 */
export const CheckboxGroup = React.memo(
  ({ children, className, error, hint, label, onBlur, onChange, hasError }: CheckboxGroupProps) => {
    return (
      <div className={clsx('InputContainer Checkboxes', className)}>
        <Fieldset label={label}>
          {React.Children.map(children, (child) => {
            return React.cloneElement(child as any, {
              onChange: onChange,
              onBlur: onBlur,
              form: { touched: {}, errors: {} },
            });
          })}
        </Fieldset>
        {hint && (
          <div className="Hints">
            <div className="Hint">{hint}</div>
          </div>
        )}
        {hasError && (
          <div className="Errors">
            <div className="Error">{getErrorDisplayText(error)}</div>
          </div>
        )}
      </div>
    );
  }
);
